import { Helmet } from 'react-helmet-async';
import ExaminationProfileView from 'src/sections/tests-results/view/examination-profile-view';
// sections

// ----------------------------------------------------------------------

export default function TestResultProfilePage() {
  return (
    <>
      <Helmet>
        <title>Dashboard: Test Response Profile</title>
      </Helmet>

      <ExaminationProfileView />
    </>
  );
}
